import { Injectable } from "@angular/core";
import { CompanyMasterData } from "../../models/domains/pbm/companies/company-master-data";
import { FiscalNumber } from "../../models/domains/pbm/fiscal-number";
import { AddIndustryProductDiscount } from "../../models/domains/pbm/industry/add-industry-product-discount.model";
import { FileIndustryProductsDiscounts } from "../../models/domains/pbm/industry/file-industry-products-discounts.model";
import { ImportIndustryProductsDiscountsResult } from "../../models/domains/pbm/industry/import-industry-products-discounts-result.model";
import { IndustryDiscountPageableResult } from "../../models/domains/pbm/industry/industry-discount-pageable-result.model";
import { IndustryDiscountSearchParameters } from "../../models/domains/pbm/industry/industry-discount-search-parameters.model";
import { IndustryDiscount } from "../../models/domains/pbm/industry/industry-discount.model";
import { IndustryProductDiscounts } from "../../models/domains/pbm/industry/industry-product-discounts.model";
import { IndustryRepository } from "../../repositories/pbm/industry.repository";

@Injectable({ providedIn: "root" })
export class IndustryDiscountsService {
  constructor(private industryRepository: IndustryRepository) {}

  public async getIndustryDiscount(indstryFiscalNumber: FiscalNumber): Promise<IndustryDiscount> {
    try {
      return await this.industryRepository.getIndustryDiscount(indstryFiscalNumber);
    } catch (error) {
      return await Promise.reject(error);
    }
  }

  public async findExistentIndustry(industryFiscalNumber: FiscalNumber): Promise<IndustryDiscount> {
    try {
      return await this.industryRepository.findExistentIndustry(industryFiscalNumber);
    } catch (error) {
      return await Promise.reject(error);
    }
  }

  public async getIndustryProductDiscounts(
    industryDiscountKey: string,
    industryDiscountSearchParameters: IndustryDiscountSearchParameters,
  ): Promise<IndustryDiscount> {
    try {
      return await this.industryRepository.getIndustryProductDiscounts(industryDiscountKey, industryDiscountSearchParameters);
    } catch (error) {
      return await Promise.reject(error);
    }
  }

  public async updateIndustryDiscountsProduct(industryProductDiscounts: IndustryProductDiscounts): Promise<any> {
    try {
      return await this.industryRepository.updateIndustryDiscountsProduct(industryProductDiscounts);
    } catch (error) {
      return await Promise.reject(error);
    }
  }

  public async getIndustryDiscountPageableResult(industryDiscountSearchParameters: IndustryDiscountSearchParameters): Promise<IndustryDiscountPageableResult> {
    try {
      return await this.industryRepository.getIndustryDiscountPageableResult(industryDiscountSearchParameters);
    } catch (error) {
      return await Promise.reject(error);
    }
  }

  public async AddIndustryProductDiscount(addIndustryProductDiscount: AddIndustryProductDiscount): Promise<any> {
    try {
      return await this.industryRepository.addIndustryProductDiscount(addIndustryProductDiscount);
    } catch (error) {
      return await Promise.reject(error);
    }
  }

  public async addIndustryProductDiscounts(fileBeneficiary: FileIndustryProductsDiscounts): Promise<ImportIndustryProductsDiscountsResult> {
    return await this.industryRepository.addIndustryProductDiscounts(fileBeneficiary);
  }

  public async deleteProduct(industryProductDiscountKey: string): Promise<any> {
    try {
      return await this.industryRepository.deleteProduct(industryProductDiscountKey);
    } catch (error) {
      return await Promise.reject(error);
    }
  }
}
